import styled from 'styled-components'

// ─────────────────────────────────────────────────────────────────────────────
// BARRA DE NAVEGAÇÃO INFERIOR (só no celular)
// Fica fixa na parte de baixo da tela, como nos apps. No computador (>=768px)
// ela some — lá continua valendo o menu do topo.
// ─────────────────────────────────────────────────────────────────────────────
export const BottomBar = styled.nav.attrs({
})`
    display: none;

    @media(max-width: 767px){
        display: flex;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 50;

        align-items: flex-end;
        justify-content: space-around;

        background: var(--primary-color);
        box-shadow: 0 -2px 12px rgba(0,0,0,.18);

        padding: 8px 6px calc(8px + env(safe-area-inset-bottom));
    }
`;

export const Tab = styled.div.attrs({
})`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    color: var(--white-color);
    opacity: ${ props => props.active ? 1 : .72 };
    ${ props => props.active ? 'font-weight: 700;' : '' }
    cursor: pointer;
`;

export const TabIcon = styled.div.attrs({
})`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg { width: 24px; height: 24px; display: block; }
`;

export const TabLabel = styled.div.attrs({
})`
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
`;

export const Avatar = styled.div.attrs({
})`
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: var(--white-color) url(${ props => props.image ? props.image : '' }) no-repeat center center / cover;
    border: 2px solid rgba(255,255,255,.85);
`;

// Botão central "Início" — círculo rosa em destaque, elevado acima da barra.
export const CenterTab = styled.div.attrs({
})`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    color: var(--white-color);
    cursor: pointer;
`;

export const CenterCircle = styled.div.attrs({
})`
    width: 54px;
    height: 54px;
    border-radius: 50%;
    margin-top: -26px;

    background: var(--secondary-color);
    border: 4px solid var(--primary-color);
    box-shadow: 0 4px 10px rgba(0,0,0,.25);

    display: flex;
    align-items: center;
    justify-content: center;

    color: var(--white-color);
    svg { width: 26px; height: 26px; display: block; }
`;

// ─────────────────────────────────────────────────────────────────────────────
// MENU DO PERFIL (abre ao tocar em "Perfil")
// ─────────────────────────────────────────────────────────────────────────────
export const Overlay = styled.div.attrs({
})`
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,.35);
    z-index: 49;

    @media(min-width: 768px){ display: none; }
`;

export const ProfilePopup = styled.div.attrs({
})`
    position: fixed;
    left: 10px;
    right: 10px;
    bottom: calc(76px + env(safe-area-inset-bottom));
    z-index: 51;

    background: var(--white-color);
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 6px 24px rgba(0,0,0,.25);

    @media(min-width: 768px){ display: none; }
`;

export const PopupProfile = styled.div.attrs({
})`
    display: flex;
    align-items: center;
    gap: 12px;

    padding: 14px 18px;
    font-size: 15px;
    color: var(--black-color);
    border-bottom: 1px solid #eee;
    cursor: pointer;

    &:active{ background: var(--backgroundgrey-color); }
`;

export const PopupProfileImage = styled.div.attrs({
})`
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: var(--backgroundgrey-color) url(${ props => props.image ? props.image : '' }) no-repeat center center / cover;
`;

export const PopupOption = styled.div.attrs({
})`
    padding: 14px 18px;
    font-size: 15px;
    color: var(--black-color);
    border-bottom: 1px solid #eee;
    cursor: pointer;

    &:active{ background: var(--backgroundgrey-color); }
    &:last-child{ border-bottom: none; }

    ${ props => props.danger ? 'color: var(--secondary-color); font-weight: 700;' : '' }
`;
